'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var formik_esm = require('../../formik.esm-e131ccca.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var ErrorText = styled__default['default'](components_Typography_Typography['default']).withConfig({
  displayName: "ErrorText",
  componentId: "sc-1szpsht-0"
})(["color:", ";margin-top:0.5rem;display:block;position:relative;"], styles_themeUtils.nuDSColor('error'));
ErrorText.propTypes = {
  children: index.propTypes.node.isRequired,
  id: index.propTypes.string.isRequired
};
ErrorText.defaultProps = {
  role: 'alert',
  variant: 'text2'
};
ErrorText.displayName = 'ErrorText';

function FieldErrorMessage(_ref) {
  var name = _ref.name,
      errorMessageId = _ref.errorMessageId;
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.ErrorMessage, {
    name: name
  }, function (msg) {
    return /*#__PURE__*/React__default['default'].createElement(ErrorText, {
      id: errorMessageId
    }, msg);
  });
}

FieldErrorMessage.propTypes = {
  errorMessageId: index.propTypes.string.isRequired,
  name: index.propTypes.string.isRequired
};

exports.default = FieldErrorMessage;
//# sourceMappingURL=FieldErrorMessage.js.map
